import React, {ButtonHTMLAttributes} from 'react';

import cs from 'classnames';

import {useCurrentUserState} from 'app/current-user/api';
import {useAccountSettings} from 'app/settings/api';
import {gt} from 'app/utils/i18n';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  className?: string;
}

export function InviteNewMemberButton({
  label = gt('Invite new member'),
  className,
  ...props
}: Props) {
  const {is_no_active_users} = useAccountSettings().data!;
  const {is_super_manager} = useCurrentUserState().data!;

  if (is_no_active_users && !is_super_manager) {
    return null;
  }

  return (
    <button className={cs('btn btn-link', className)} {...props}>
      {label}
    </button>
  );
}
